import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import ShowCard from "../ShowCard/ShowCard";
import { ReactComponent as Arrow } from "../../assets/Icons/filledArrow.svg";
import { useSelector } from "react-redux";
import { useWindowWidth } from "@react-hook/window-size";
import { Link, useNavigate} from "react-router-dom";
import Translate from "../Multilanguage/Translate";
const ShowsRow = ({ season, data,type, title, metaData,watchVideoHandler,setVideoPlayer,similarVideos,showname ,showDetailsData, showId, isChallenge }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [rowItemCountNumber, setRowItemCountNumber] = useState(5);
  const [seasonButton, setSeasonButton] = useState(false);
  const [details, setDetails] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [seasonName,setSeasonName] = useState("")
  const navigate = useNavigate();
  const windowSize = useWindowWidth();
  const seasonContainerRef = useRef(null);
  const thumbnailOrientation = projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;
  const theme =projectInfo?.projectConfig?.config?.THEME ;

    useEffect(() => {
      if (windowSize > 980) {
        if(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) {
          setRowItemCountNumber(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT);
        } else {
          setRowItemCountNumber(4);
        }
      } else {
        if(thumbnailOrientation === "LANDSCAPE"){
        if (windowSize > 767){
          setRowItemCountNumber(2);
        } else if (windowSize > 319){
          setRowItemCountNumber(1);
        }
      } else if(thumbnailOrientation === "PORTRAIT"){
        if (windowSize > 767){
          setRowItemCountNumber(4);
        } else if (windowSize > 319){
          setRowItemCountNumber(3);
        }
      }
    }
    }, [projectInfo, windowSize]);

  useEffect(() => {
    if (data && !season) {
      setDetails(data);
    } else {
        setDetails(data[0]?.videos)
      setSeasons(data);
      if (data[0]?.season)
        { setSeasonName(data[0].season); } 
    }
  }, [data]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (seasonContainerRef.current && !seasonContainerRef.current.contains(event.target)) {
        setSeasonButton(false);
      }
    };

    if (seasonButton) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [seasonButton]);

  const count = details?.length;
  let displayedData = details;

  if (isRTL && count > rowItemCountNumber) {
    displayedData = [...details].reverse();
  }

  const handleShowAllClick = (selectedSeasonData) => {
    navigate(`/episodes/${showDetailsData?.vanity_url}`, { state: { selectedSeasonData, showname, showDetailsData } });
  };
 
  return (
    <div className={`showsRow ${isRTL ? (count > rowItemCountNumber ? "ltr" : windowSize < 980 ? "rtl" : "rtl" ) : ""}`} 
      aria-labelledby={`title`}
      role="region">
      {title && <h1 className="heading">{title}</h1>}
     
      {season && (
        <div
          ref={seasonContainerRef}
          className={seasonButton?"seasonContainer zIndexController":"seasonContainer" }
          onClick={() => setSeasonButton(!seasonButton)}
           onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSeasonButton(!seasonButton);
        } else if (e.key === 'Escape' && seasonButton) {
          setSeasonButton(false);
        } else if (e.key === 'ArrowDown' && seasonButton) {
          e.preventDefault();
          const firstItem = document.querySelector('.list.active .item');
          if (firstItem) firstItem.focus();
        }
      }}
      aria-expanded={seasonButton}
      aria-haspopup="listbox"
      aria-label={`Select season, currently ${seasonName || seasons[0]?.season}`}
      tabIndex={0}
        >
          <span className="selected">{seasonName || seasons[0]?.season}</span>
        <div className={season?.length>5?"listContainer scroll":"listContainer"}>

          <div className={seasonButton ? "list active" : "list"}
               role="listbox"
               aria-label="Available seasons">
            {seasons?.map((item, index) => (
              <div className={`item ${theme === "LIGHT" ? "whiteBg" : ""}`} key={index} onClick={()=>{setDetails(item?.videos);setSeasonName(item?.season)}}>
                <span>{item?.season}</span>
              </div>
            ))}
           
            
          </div>
        </div>
          <Arrow className={seasonButton ? "active" : "no-active"} />
        </div>
      )}
       { title?.props?.textKey !== "you_may_also_like" &&(
        <li className="showall"> 

          <button onClick={() => handleShowAllClick(details)}><Translate textKey={'show_all'}/> ({details.length})</button>

        </li>
      )}
      <Swiper
        key={isRTL ? (count > rowItemCountNumber ? "ltr" : windowSize < 980 ? "rtl" : "rtl" ) : ""}
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={10}
        slidesPerView={4}
        navigation={true}
        watchSlidesProgress
        loop={false}
        initialSlide={(isRTL && count > rowItemCountNumber) ? count - 1 : 0}
        breakpoints={{
          320: {
            slidesPerView: thumbnailOrientation==="PORTRAIT"?3:1,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: thumbnailOrientation==="PORTRAIT"?4:2,
            spaceBetween: 10,
          },
          980: {
            slidesPerView:  projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT?projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT:4,
            spaceBetween: 10,
          },
        }}
      >
        {displayedData?.map((item, index) => (
          <SwiperSlide key={index}>
            {/* <div className="show" onClick={()=>similarVideos?setVideoPlayer(null):watchVideoHandler(item)}> */}
            <div className="show">
              <ShowCard
                season={season ? true : false}
                data={item}
                imageUrl={true}
                metaData={metaData ? true : false}
                type={type}
                thumbnailOrientation={thumbnailOrientation}
                showId={showId}
                isChallenge={isChallenge}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ShowsRow;
